import { isObject } from '@vista-digital/validator';
/**
 * Returns true if objects have the same values.
 */
export const areObjectsEquivalent = (o1, o2) => {
    const keys1 = Object.keys(o1);
    const keys2 = Object.keys(o2);
    if (keys1.length !== keys2.length)
        return false;
    for (const key of keys1) {
        const val1 = o1[key];
        const val2 = o2[key];
        const areObjects = isObject(val1) && isObject(val2);
        const areArrays = Array.isArray(val1) && Array.isArray(val2);
        if (areObjects && !areObjectsEquivalent(val1, val2))
            return false;
        else if (areArrays && !areArraysEquivalent(val1, val2))
            return false;
        else if (!areObjects && !areArrays && val1 !== val2)
            return false;
    }
    return true;
};
/**
 * Returns true if objects have different values.
 */
export const areObjectsNotEquivalent = (o1, o2) => {
    return !areObjectsEquivalent(o1, o2);
};
/**
 * Returns true if the two arrays are equal. Note this also takes order into account.
 */
export const areSortedArraysEquivalent = (array1, array2) => {
    if (array1.length !== array2.length)
        return false;
    if (Array.isArray(array1[0])) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return array1.every((_, i) => areSortedArraysEquivalent(array1[i], array2[i]));
    }
    if (isObject(array1[0])) {
        return array1.every((_, i) => areObjectsEquivalent(array1[i], array2[i]));
    }
    return array1.every((_, i) => array1[i] === array2[i]);
};
/**
 * Returns true if the two arrays are equal. Note this does **not** take order into account.
 */
export const areArraysEquivalent = (array1, array2) => {
    return areSortedArraysEquivalent([...array1].sort(), [...array2].sort());
};
/**
 * Returns true if the provided values are equal or are both one of null/undefined.
 */
export const areValuesEqualOrBothUndefined = (a, b) => a === b || (a == null && b == null);
